


import React, { useEffect, useState } from "react";
import lago from "../../assets/image/bill_logo.png";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";

// Utility function to convert number to words (INR)
const numberToWords = (num) => {
  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = [
    "",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  if (num === 0) return "Zero";

  const convert = (n) => {
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return `${tens[Math.floor(n / 10)]} ${units[n % 10]}`.trim();
    if (n < 1000) return `${units[Math.floor(n / 100)]} Hundred ${convert(n % 100)}`.trim();
    return n;
  };

  const parts = [];
  let remaining = Math.floor(num);
  let i = 0;

  while (remaining > 0) {
    let chunk;
    if (i === 0) chunk = remaining % 1000;
    else if (i === 1) chunk = remaining % 100;
    else if (i === 2) chunk = remaining % 100;
    else chunk = remaining;

    if (chunk > 0) {
      parts.unshift(`${convert(chunk)} ${thousands[i]}`.trim());
    }
    remaining = Math.floor(remaining / (i === 0 ? 1000 : 100));
    i++;
  }

  const paise = Math.round((num % 1) * 100);
  let result = parts.join(" ");
  if (paise > 0) result += ` and ${convert(paise)} Paise`;
  return result + " Only";
};

const Purchase_Bill = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState({});
  const [isPrinting, setIsPrinting] = useState(true); // State to control print behavior

  useEffect(() => {
    fetchPurchaseData();
  }, [id]);

  useEffect(() => {
    if (isPrinting) {
      const printTimeout = setTimeout(() => {
        window.print();
        // Set a timeout to detect if print is canceled (onafterprint not triggered)
        const cancelTimeout = setTimeout(() => {
          if (isPrinting) {
            setIsPrinting(false);
            navigate("/purchases"); // Navigate to /purchases if print is canceled
          }
        }, 500); // Assume cancellation if no print action within 5 seconds

        window.onafterprint = () => {
          clearTimeout(cancelTimeout); // Clear cancel timeout if print completes
          setIsPrinting(false);
          navigate(-1); // Navigate back to previous page after printing
        };

        return () => {
          clearTimeout(cancelTimeout);
          window.onafterprint = null;
        };
      }, 500); // Slight delay to allow DOM rendering

      return () => {
        clearTimeout(printTimeout);
        window.onafterprint = null;
      };
    }
  }, [navigate, isPrinting]);

  const fetchPurchaseData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/purchase_data.php`);
      const allData = response.data.data;
      const matchedPurchase = allData.find((purchase) => purchase.id === id);

      if (matchedPurchase) {
        setResponseData(matchedPurchase);
      } else {
        console.warn("No purchase found with ID:", id);
        setResponseData({});
      }
    } catch (err) {
      console.error("Error fetching purchase data: ", err.message);
    }
  };

  // Calculate tax table data
  const taxTableData = responseData.purchaseItems
    ? responseData.purchaseItems.map((item) => {
        const taxableValue = item.purchase_rate * item.purchase_quantity;
        const cgstRate = item.purchase_gst / 2; // Split GST equally between CGST and SGST
        const sgstRate = item.purchase_gst / 2;
        const cgstAmount = (taxableValue * cgstRate) / 100;
        const sgstAmount = (taxableValue * sgstRate) / 100;
        const totalTaxAmount = cgstAmount + sgstAmount;

        return {
          hsn: item.HSN_code,
          taxableValue: taxableValue.toFixed(2),
          cgstRate: cgstRate.toFixed(2),
          cgstAmount: cgstAmount.toFixed(2),
          sgstRate: sgstRate.toFixed(2),
          sgstAmount: sgstAmount.toFixed(2),
          totalTaxAmount: totalTaxAmount.toFixed(2),
        };
      })
    : [];

  // Calculate totals for the tax table
  const totalTaxableValue = taxTableData.reduce((sum, item) => sum + parseFloat(item.taxableValue), 0).toFixed(2);
  const totalCgstAmount = taxTableData.reduce((sum, item) => sum + parseFloat(item.cgstAmount), 0).toFixed(2);
  const totalSgstAmount = taxTableData.reduce((sum, item) => sum + parseFloat(item.sgstAmount), 0).toFixed(2);
  const totalTaxAmount = taxTableData.reduce((sum, item) => sum + parseFloat(item.totalTaxAmount), 0).toFixed(2);

  // Calculate total amount (subTotal + gstAmount)
  const totalAmount = responseData.subTotal && responseData.gstAmount ? (parseFloat(responseData.subTotal) + parseFloat(responseData.gstAmount)).toFixed(2) : "0.00";
  const roundOff = (Math.round(totalAmount) - totalAmount).toFixed(2);
  const finalTotal = Math.round(totalAmount).toFixed(2);

  return (
    <div
      className="a4-wrapper"
      style={{
        width: "210mm",
        minHeight: "297mm",
        margin: "0 auto",
        backgroundColor: "white",
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
      }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="text-center mb-1">
          <h1 style={{ fontSize: "20px", fontWeight: "bold" }}>PURCHASE DETAILS</h1>
        </div>

        {/* Seller/Buyer and Invoice Info */}
        <div className="row border border-bottom-0 border-dark">
          <div className="col-md-6 p-0 border-end border-dark">
            <div className="row m-0 border-bottom border-dark">
              <div className="col-5 p-2 border-end-0 border-dark d-flex align-items-center justify-content-center">
                <div>
                  <img src={lago} style={{ height: "75px", width: "150px",objectFit:'contain' }} alt="Krishna Tyres Logo" />
                </div>
              </div>
              <div className="col-7 p-1">
                <div className="fw-bold">KRISHNA TYRES</div>
                <div>DEO BAND ROAD, NANAUTA DIST</div>
                <div>SAHARANPUR</div>
                <div>GSTIN/UIN: 09BRXPM3098K1ZP</div>
                <div>State Name: Uttar Pradesh, Code: 09</div>
                <div>Contact: 9719197977</div>
                <div>Email: abc@gmail.com</div>
              </div>
            </div>

            <div className="p-1">
              <div className="fw-bold">Buyer</div>
              <div className="fw-semibold">Sri Krishna Tyres</div>
              <div>MRF TYRES AND SERVICE FRANCHISE</div>
              <div>Pincode:636502</div>
              <div>Ph: Mobile: 9524030256</div>
              <div>GST No:33BCOPM0715M1ZG</div>
            </div>
          </div>

          <div className="col-md-6 p-0">
            <div className="row m-0 border-bottom border-dark">
              <div className="col-md-7 p-1 border-end border-dark">
                <div className="row">
                  <div className="col-5">Invoice</div>
                  <div className="col-7 text-end">e-Way Bill No.</div>
                </div>
                <div className="row">
                  <div className="col-5 fw-bold">{responseData.purchaseId || "N/A"}</div>
                  <div className="col-7 fw-bold text-end"></div>
                </div>
              </div>
              <div className="col-md-5 p-1">
                <div className="text-end fw-semibold">Dated</div>
                <div className="text-end fw-bold">
                  {responseData.purchasePaymentHistory?.[0]?.date ?? "No date available"}
                </div>
              </div>
            </div>

            {[
              ["Delivery Note", "Mode/Terms of Payment"],
              ["Supplier's Ref.", "Other Reference(s)"],
              ["Buyer's Order No.", "Dated"],
              ["Despatch Document No.", "Delivery Note Date"],
              ["Despatched through", "Destination"],
            ].map(([left, right], i) => (
              <div key={i} className="row m-0 border-bottom border-dark">
                <div className="col-md-7 p-1 border-end border-dark">{left}</div>
                <div className="col-md-5 p-1">{right}</div>
              </div>
            ))}

            <div className="row m-0">
              <div className="col-md-7 p-1 border-end border-dark">
                Bill of Lading/LR-RR No.
                <div className="fw-bold">dt. 21-Feb-2021</div>
              </div>
              <div className="col-md-5 p-1">
                Motor Vehicle No.
                <div className="fw-bold">UP11AT4185</div>
              </div>
            </div>
            <div className="row m-0 border-top border-dark">
              <div className="col-12 mb-5">Terms of Delivery</div>
            </div>
          </div>
        </div>

        {/* Item Table + Amount in Words Combined */}
        <div className="row">
          <table
            className="table border border-dark border-top-0 mb-0 h-60"
            style={{ borderCollapse: "collapse" }}
          >
            <thead>
              <tr>
                <th className="text-center border border-dark" style={{ width: "1%" }}>
                  S.No
                </th>
                <th className="text-center border border-dark" style={{ width: "33%" }}>
                  Description of Goods
                </th>
                <th className="text-center border border-dark" style={{ width: "10%" }}>
                  HSN/SAC
                </th>
                <th className="text-center border border-dark" style={{ width: "10%" }}>
                  Quantity
                </th>
                <th className="text-center border border-dark" style={{ width: "10%" }}>
                  Rate
                </th>
                <th className="text-center border border-dark" style={{ width: "5%" }}>
                  Per
                </th>
                <th className="text-center border border-dark" style={{ width: "15%" }}>
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              {responseData.purchaseItems?.map((item, i) => (
                <tr key={i}>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {i + 1}
                  </td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {item.Category}({item.Subcategory}{item.tyre_size})
                  </td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {item.HSN_code}
                  </td>
                  <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {item.purchase_quantity} PC
                  </td>
                  <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {item.purchase_rate}
                  </td>
                  <td className="text-end border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    PC
                  </td>
                  <td className="text-end fw-bold border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {(item.purchase_rate * item.purchase_quantity).toFixed(2)}
                  </td>
                </tr>
              ))}

              {/* Empty Rows to Fill Space */}
              {Array.from({ length: 4 - (responseData.purchaseItems?.length || 0) }).map((_, i) => (
                <tr key={`empty-${i}`}>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end fw-bold border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                </tr>
              ))}

              {/* Totals Row */}
              <tr>
                <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                  {responseData.purchaseItems?.reduce((sum, item) => sum + parseInt(item.purchase_quantity), 0) || 0} PC
                </td>
                <td className="text-end fw-bold border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                <td className="text-end fw-bold border-top fs-6 border-dark">{responseData.subTotal || "0.00"}</td>
              </tr>

              {/* Tax Rows */}
              {[
                { label: "Output CGST @ 14%", rate: responseData.purchaseItems?.[0]?.purchase_gst / 2, amount: responseData.gstAmount ? (parseFloat(responseData.gstAmount) / 2).toFixed(2) : "0.00" },
                { label: "Output SGST @ 14%", rate: responseData.purchaseItems?.[1]?.purchase_gst / 2 || responseData.purchaseItems?.[0]?.purchase_gst / 2, amount: responseData.gstAmount ? (parseFloat(responseData.gstAmount) / 2).toFixed(2) : "0.00" },
                { label: "Output CGST @ 9%", rate: 9, amount: ((responseData.subTotal || 0) * 9 / 100).toFixed(2) },
                { label: "Output SGST @ 9%", rate: 9, amount: ((responseData.subTotal || 0) * 9 / 100).toFixed(2) },
                { label: "Round Off", rate: "", amount: roundOff },
              ].map((tax, i) => (
                <tr key={i}>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {tax.label}
                  </td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}></td>
                  <td className="text-end border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {tax.rate ? `${tax.rate}%` : ""}
                  </td>
                  <td className="border-end border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {tax.rate ? "%" : ""}
                  </td>
                  <td className="text-end fw-bold border-dark" style={{ borderTop: "none", borderBottom: "none" }}>
                    {tax.amount}
                  </td>
                </tr>
              ))}

              {/* Final Total Row */}
              <tr>
                <td className="border-end border-top border-dark"></td>
                <td className="text-end border-end border-top border-dark fw-bold">Total</td>
                <td className="border-end border-top border-dark"></td>
                <td className="text-end fw-bold border-end border-top border-dark">
                  {responseData.purchaseItems?.reduce((sum, item) => sum + parseInt(item.purchase_quantity), 0) || 0} PC
                </td>
                <td className="border-end border-top border-dark"></td>
                <td className="border-end border-top border-dark"></td>
                <td className="text-end fw-bold border-top border-dark">₹ {finalTotal}</td>
              </tr>
            </tbody>
          </table>

          <div className="col-12 border border-dark border-bottom-0 border-top-0 m-0 p-1">
            <div className="d-flex justify-content-between">
              <span>Amount Chargeable (in words)</span>
              <span>E. & O.E</span>
            </div>
            <div className="fw-bold">INR {numberToWords(parseFloat(finalTotal))}</div>
          </div>
        </div>

        {/* Tax Table */}
        <div className="row">
          <table className="table border border-dark" style={{ borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th rowSpan="2" className="text-center border-end border-dark">
                  HSN/SAC
                </th>
                <th rowSpan="2" className="text-center border-end border-dark">
                  Taxable Value
                </th>
                <th colSpan="2" className="text-center border-end border-dark">
                  Central Tax
                </th>
                <th colSpan="2" className="text-center border-end border-dark">
                  State Tax
                </th>
                <th rowSpan="2" className="text-center border-end border-dark">
                  Total Tax Amount
                </th>
              </tr>
              <tr>
                <th className="text-center border-dark border-end">Rate</th>
                <th className="text-center border-dark border-end">Amount</th>
                <th className="text-center border-dark border-end">Rate</th>
                <th className="text-center border-dark border-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {taxTableData.length > 0 ? (
                taxTableData.map((item, index) => (
                  <tr key={index}>
                    <td className="border-dark border-end border-bottom-0">{item.hsn}</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.taxableValue}</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.cgstRate}%</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.cgstAmount}</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.sgstRate}%</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.sgstAmount}</td>
                    <td className="text-end border-dark border-end border-bottom-0">{item.totalTaxAmount}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No data available
                  </td>
                </tr>
              )}

              <tr className="fw-bold border border-dark">
                <td className="text-end border-end border-dark">Total</td>
                <td className="text-end border-end border-dark">{totalTaxableValue}</td>
                <td className="border-dark border-end"></td>
                <td className="text-end border-end border-dark">{totalCgstAmount}</td>
                <td className="border-dark border-end"></td>
                <td className="text-end border-end border-dark">{totalSgstAmount}</td>
                <td className="text-end border-end border-dark">{totalTaxAmount}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bank & Footer */}
        <div className="row border border-dark border-top-0 border-bottom-0" style={{ marginTop: "-17px" }}>
          <div className="col-12 mt-1">
            Tax Amount (in words): <span className="fw-bold">INR {numberToWords(parseFloat(totalTaxAmount))}</span>
          </div>
          <div className="col-12 mt-2">
            <div className="fw-medium">Company's Bank Details</div>
            <div className="row mt-1">
              <div className="col-md-2">Bank Name</div>
              <div className="col-md-1" style={{ marginLeft: "-5%" }}>:</div>
              <div className="col-md-9 fw-bold" style={{ marginLeft: "-5%" }}>
                Shivalik Mercantile Co-Operative Bank Ltd.
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">A/C NO.</div>
              <div className="col-md-1" style={{ marginLeft: "-5%" }}>:</div>
              <div className="col-md-9 fw-bold" style={{ marginLeft: "-5%" }}>145879652369</div>
            </div>
            <div className="row">
              <div className="col-md-2">Branch & IFSC</div>
              <div className="col-md-1" style={{ marginLeft: "-5%" }}>:</div>
              <div className="col-md-9 fw-bold" style={{ marginLeft: "-5%" }}>Nanauta & SMCB0001013</div>
            </div>
          </div>
        </div>

        <div className="row border border-dark">
          <div className="col-md-6 p-1">
            <div className="text-decoration-underline">Declaration</div>
            <p className="mt-1 mb-0">
              We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
            </p>
          </div>
          <div className="col-md-6 p-1 text-end">
            <div className="fw-bold">for KRISHNA TYRES</div>
            <div className="mt-4">Authorised Signatory</div>
          </div>
        </div>
      </div>

      <style>{`
        @page {
          size: A4;
          margin: 0;
        }

        body {
          background: white !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .a4-wrapper {
          page-break-after: always;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th,
        td {
          padding: 2px 4px !important;
        }

        @media print {
          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            width: 210mm;
            height: 297mm;
          }

          .a4-wrapper {
            border: 1px solid #000 !important;
            margin: 0 auto !important;
            page-break-after: always;
          }

          .container-fluid {
            padding: 10mm !important;
            margin: 0 !important;
          }

          table {
            page-break-inside: avoid;
          }
        }
      `}</style>
    </div>
  );
};

export default Purchase_Bill;